import React from 'react';

export const EmployeePerformanceCard = ({ title, value, icon, color = "blue" }) => {
  const colorClasses = {
    blue: { bg: "bg-blue-50", border: "border-blue-200", text: "text-blue-600", bgIcon: "bg-blue-100" },
    green: { bg: "bg-green-50", border: "border-green-200", text: "text-green-600", bgIcon: "bg-green-100" },
    purple: { bg: "bg-purple-50", border: "border-purple-200", text: "text-purple-600", bgIcon: "bg-purple-100" },
    red: { bg: "bg-red-50", border: "border-red-200", text: "text-red-600", bgIcon: "bg-red-100" },
  };

  const colors = colorClasses[color] || colorClasses.blue;

  return (
    <div className={`p-4 rounded-lg border ${colors.bg} ${colors.border}`}>
      <div className="flex items-center gap-3">
        <div className={`w-8 h-8 rounded-full flex items-center justify-center ${colors.bgIcon}`}>
          {React.cloneElement(icon, { className: `h-4 w-4 ${colors.text}` })}
        </div>
        <div>
          <p className={`text-sm font-medium ${colors.text}`}>{title}</p>
          <p className="text-xl font-bold">
            {typeof value === 'number' && title.includes('$') ? `$${value}` : value}
          </p>
        </div>
      </div>
    </div>
  );
};